<template>
  <div>
    <BasicModal
      :title="'一括アクション'"
      :canCancel="true"
      :isShowModal="isShowModal"
      @cancel="cancel">
    <div class="bulk-action-container">
      <div style="display: flex; flex-wrap: wrap;">
        <button class="button is-primary action-button"
          @click="clickBulkSendEmail">
          <span class="mdi mdi-email"></span>
          メール一括送付
        </button>
        <button v-if="user.companySMSTEL" class="button is-primary action-button"
          @click="clickBulkSendSMS">
          <span class="mdi mdi-email"></span>
          SMS一括送付
        </button>
        <button class="button is-primary action-button"
          @click="bulkAcknowledgedNew">
          <span class="mdi mdi-account-check"></span>
          [新着]一括確認済み
        </button>
        <button class="button is-primary action-button"
          @click="bulkAcknowledgedResponsed">
          <span class="mdi mdi-account-check"></span>
          [新規ロボ回答有]一括確認済み
        </button>
        <button class="button is-primary action-button"
          @click="bulkArchive"
          v-if="!archiveSwitch && !blacklistSwitch">
          <span class="mdi mdi-archive"></span>
          一括アーカイブ
        </button>
        <button class="button is-primary action-button"
          @click="bulkRestore"
          v-if="archiveSwitch && !blacklistSwitch">
          <span class="mdi mdi-backup-restore"></span>
          一括で応募者一覧に戻す
        </button>
        <button class="button is-primary action-button"
          @click="clickBulkManage"
          v-if="select_manages.length > 0 && !blacklistSwitch">
          <span class="mdi mdi-window-restore"></span>
          応募者一括振り分け
        </button>
        <button class="button is-primary action-button"
          @click="bulkDelete"
          v-if="archiveSwitch && !blacklistSwitch">
          <span class="mdi mdi-delete"></span>
          一括削除
        </button>
        <button class="button is-primary action-button"
          @click="bulkStageStatus">
          <span class="mdi mdi-clipboard-flow"></span>
          ステージ・ステータス一括変更
        </button>
      </div>
    </div>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'

export default {
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
    },
    archiveSwitch: {
      type: Boolean,
      required: true,
    },
    blacklistSwitch: {
      type: Boolean,
      required: true,
    },
    bulkSeekerList: {
      type: Array,
      required: false
    },
    select_manages: {
      type: Array,
      required: false
    },
    user: {
      type: Object,
      required: true
    },
    recruitmentFlows: {  // 新しく追加
      type: Array,
      required: true
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    clickBulkSendEmail () {
      this.$emit('cancel', false)
      this.$emit('clickBulkSendEmail', 'email')
    },
    clickBulkSendSMS () {
      this.$emit('cancel', false)
      this.$emit('clickBulkSendSMS')
    },
    clickBulkManage () {
      this.$emit('cancel', false)
      this.$emit('clickBulkManage', 'manage')
    },
    bulkAcknowledgedNew () {
      const targets = this.bulkSeekerList.filter(seeker => seeker.is_new == true)
      if (targets.length > 0) {
        // 新着を確認済みにする場合、ロボ新規回答有は確認済みにしない
        this.$emit('acknowledgedSeeker', targets, {'is_new': false})
      }
      this.$emit('emptyBulkSeekerList')
      this.$emit('cancel', false)
    },
    bulkAcknowledgedResponsed () {
      const targets = this.bulkSeekerList.filter(seeker => seeker.is_responsed == true)
      if (targets.length > 0) {
        // ロボ新規回答有を確認済みにする場合、新着も確認済みにする
        this.$emit('acknowledgedSeeker', targets, {'is_new': false, 'is_responsed': false})
      }
      this.$emit('emptyBulkSeekerList')
      this.$emit('cancel', false)
    },
    bulkArchive () {
      const targets = this.bulkSeekerList.filter(seeker => seeker.is_archive == false)
      if (targets.length > 0) {
        this.$emit('archiveSeeker', targets, true)
      }
      this.$emit('emptyBulkSeekerList')
      this.$emit('cancel', false)
    },
    bulkRestore () {
      const targets = this.bulkSeekerList.filter(seeker => seeker.is_archive == true)
      if (targets.length > 0) {
        this.$emit('archiveSeeker', targets, false)
      }
      this.$emit('emptyBulkSeekerList')
      this.$emit('cancel', false)
    },
    bulkDelete () {
      const targets = this.bulkSeekerList.filter(seeker => seeker.is_archive == true)
      if (targets.length > 0) {
        this.$emit('logicalDeleteSeeker', targets)
      }
      this.$emit('cancel', false)
    },
    bulkStageStatus() {
      this.$emit('clickBulkStageStatus', this.bulkSeekerList)
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.bulk-action-container {
  padding: 8px;
}
.action-button {
  width: calc(50% - 16px);
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/modals/ModalBulkAction.vue